import { privateRequest } from "../axios";

const ENDPOINTS = {
  CUSTOMER: "/customer",
  CUSTOMER_ID: (id) => `/customer/${id}`,
//   USER_EXPORT: '/customer/export',
};

const getCustomer = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.CUSTOMER, { params });
  return response?.data;
};

const  getCustomerById = async (id) => {
  const response = await privateRequest.get(ENDPOINTS.CUSTOMER_ID(id));
  return response?.data;
};

// const addUser = async (data) => {
//   const response = await privateRequest.post(ENDPOINTS.USER, data);
//   return response?.data;
// };

// const updateUser = async (id, data) => {
//   const response = await privateRequest.put(ENDPOINTS.USER_ID(id), data);
//   return response?.data;
// };

// const deleteUser = async (id) => {
//   const response = await privateRequest.delete(ENDPOINTS.USER_ID(id));
//   return response?.data;
// };

// const getUserExport = async (id) => {
//   const response = await privateRequest.get(ENDPOINTS.USER_EXPORT(id));
//   return response?.data;
// };

// const getUserExport = async (params) => {
//   const response = await privateRequest.get(ENDPOINTS.USER_EXPORT, {
//     params, // will be undefined or an object like { roleId: 1 }
//   });
//   return response?.data;
// };


// const getUserExport = async (query = "") => {
//   const url = `${ENDPOINTS.USER_EXPORT}${query}`;
//   const response = await privateRequest.get(url);
//   return response?.data;
// };
const CustomerService = {
  getCustomer,
  getCustomerById,
//   addUser,
//   updateUser,
//   deleteUser,
//   getUserExport

};

export default CustomerService;
